import store from "redux/store"
import { changeAshiCount, changeChartDate } from "redux/ducks/Chart"

export const checkDataSpan = (
  startDate: number,
  endDate: number,
  _controller: any
) => {
  if (!_controller) return [false, null, null]
  // 期間チェック(本数25以下の場合は、変更しない)・・・trueが超えている場合
  if (_controller.Chart.CheckChartSpan(startDate, endDate))
    return [true, startDate, endDate]
  let res = _controller.Chart.GetChartSpan()
  let startSpan = res.$0
  let endSpan = res.$1 ? res.$1.$0 : null
  return [false, startSpan, endSpan]
}

export const updateSpan = (
  startDate: number,
  endDate: number,
  _controller: any
) => {
  let res = _controller.Chart.UpdateVPortStartEnd(startDate, endDate)
  let ashi = res.$0
  let startSpan = res.$1 ? res.$1.$0 : null
  let endSpan = startSpan ? (res.$1.$1 ? res.$1.$1.$0 : null) : null
  _controller.Chart.Draw()
  return [ashi, startSpan, endSpan]
}

export const convertDate = (value: number) => {
  const _value = String(value)
  const year = _value.slice(0, 4)
  const month =
    _value.slice(4, 6).slice(0, 1) === "0"
      ? _value.slice(5, 6)
      : _value.slice(4, 6)
  const day =
    _value.slice(6).slice(0, 1) === "0" ? _value.slice(7) : _value.slice(6)
  return [Number(year), Number(month) - 1, Number(day)]
}

export const getAshiCountandSpan = (_controller: any) => {
  if (!_controller) return []
  let res = _controller.Chart.GetChartSpan()
  let startSpan = res.$0
  let endSpan = res.$1 ? res.$1.$0 : undefined
  let ashi = endSpan ? (res.$1.$1 ? res.$1.$1.$0 : undefined) : undefined
  return [ashi, startSpan, endSpan]
}

export const getFutureSpan = (_controller: any) => {
  if (!_controller) return 0
  return _controller.Chart.GetFutureSpan()
}

export const resetUiSpan = (canvasID: string, _controller: any) => {
  // 以下、見直しが必要。
  setTimeout(() => {
    if (!_controller) return
    const [ashi, startData, EndData] = getAshiCountandSpan(_controller)
    if (!ashi) return
    const _sspan = convertDate(startData)
    const _espan = convertDate(EndData)
    store.dispatch(changeAshiCount(canvasID, ashi))
    store.dispatch(
      changeChartDate(canvasID, [
        new Date(_sspan[0], _sspan[1], _sspan[2]),
        new Date(_espan[0], _espan[1], _espan[2]),
      ])
    )
  }, 100)
}
